import React from 'react';
import './Signal.css';

const Signal = () => {
  return (
    <section className="signal" id="signal" data-testid="signal-section">
      <div className="section-content">
        <h2 className="section-header" data-testid="signal-header">Signal</h2>
        
        <div className="signal-placeholder" data-testid="signal-placeholder">
          <p>Transmitting soon.</p>
        </div>
      </div>
    </section>
  );
};

export default Signal;
